export default __webpack_public_path__ + "static/media/waves.1c7c40b8.svg";